const searchText = (value: unknown) =>
	typeof value === "string" ||
	typeof value === "number" ||
	typeof value === "boolean"
		? String(value)
		: "";

const searchPage = (value: unknown) => {
	const page =
		typeof value === "number" || typeof value === "string"
			? Number(value)
			: NaN;
	return Number.isSafeInteger(page) && page >= 0 ? page : 0;
};

const searchTags = (value: unknown) => [
	...new Set(
		(Array.isArray(value) ? value : [value]).filter(
			(tag): tag is string => typeof tag === "string" && tag.length > 0,
		),
	),
];

// Do not add search defaults to every CMS URL, or discard client-specific params.
export function validateSearch(search: Record<string, unknown>) {
	return {
		...search,
		...(search.q !== undefined ? { q: searchText(search.q) } : {}),
		...(search.page !== undefined ? { page: searchPage(search.page) } : {}),
		...(search.tags !== undefined ? { tags: searchTags(search.tags) } : {}),
	};
}

export function getSearchParams(
	search: Record<string, unknown>,
	culture: string,
) {
	return {
		culture,
		q: searchText(search.q),
		page: searchPage(search.page),
		"tags[]": searchTags(search.tags),
	};
}
